import {
  PLATFORM_THEMES,
  type ThemeChoice,
  themeClass,
} from "../../lib/platformIdentity";
import "./PlatformThemePicker.css";

// The classes for a theme choice's color dot, wherever it shows: in this
// picker's options, in the Details section's theme tile, and beside the
// logo in the read-only identity row. The dot carries the same theme class
// the platform page wears (themeClass), so it previews the real accent,
// neutral included, and stays correct inside a themed page where
// --bfc-theme would otherwise inherit the page's theme.
export function themeSwatchClass(theme: ThemeChoice): string {
  return `platform-theme-swatch-dot ${themeClass(theme)}`;
}

// The theme part of a platform's identity, as an options list inside the
// Details section's theme dropdown.
export function PlatformThemePicker({
  value,
  onChange,
}: {
  value: ThemeChoice;
  onChange: (theme: ThemeChoice) => void;
}) {
  const options: { value: ThemeChoice; label: string }[] = [
    { value: "neutral", label: "Neutral" },
    ...PLATFORM_THEMES,
  ];

  return (
    <div className="platform-theme-options" role="listbox" aria-label="Theme">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className="platform-theme-option"
          role="option"
          aria-selected={value === option.value}
          onClick={() => onChange(option.value)}
        >
          <span className={themeSwatchClass(option.value)} />
          {option.label}
        </button>
      ))}
    </div>
  );
}
